/* 项目详情 */
export const javaObject = `query javaObject($id: ID! = 1){
  javaObject(id: $id){
    id
    logo{
      url
    }
    objectName
    objectSubtitle
    objectIntroduction
    about
    videoUrl
    videoDesc
    topImg{
      url
    }
    botImg{
      url
    }
    videoBackground{
      url
    }
    bannerImg{
		  url
    }
    webbannerItems{
      lab
      num
      icon{
        url
      }
    }
    bannerColor
    platColor
    platIsOpen
    platTitle
    platSubTitle
    platEnTitle
    playBgImg{
      url
    }
    plateform{
      title
      subtitle
      icon{
        url
      }
      rwm{
        url
      }
      LableTree{
        id
        title
        subtitle
        icon{
          url
        }
        content{
          id
          title
          url
          subTitle
          file{
            url
          }
        }
      }
    }
    modular{
      id
      title
      subTitle
      bgColor
      bgImg{
        url
      }
      file{
        url
      }
      url
    }
    program{
      title
      subTitle
      desc
      AboutImage{
        id
        title
        about
        image{
        url
      }
      }
      bgColor
      bgImg{
        url
      }
    }
    classTitle
    classEnTitle
    classList{
      id
      title
      subTitle
      desc
    }
    actionlabel
    actionImg{
      url
    }
    teachModleTitle
    TeachEnTitle
    teachBgColor
    teachBgImg{
      url
    }
    teachers{
      name
      showName
      quarters
      headerImage {
        url
      }
      details
      isPublic
      sortNum
    }
    teacheres{
      id
      name
      quarters
      headerImage {
        url
      }
      details
      isPublic
      sortNum
    }
    teachBgColor
    teachBgImg{
        url
      }
  }
}`